<template>
  <div class="main-wrap">
    <page-bread />
    <el-container class="home-container">
      <el-aside width="292px">
        <page-aside>
          <el-menu :default-active="activeIndex" router>
            <el-menu-item
              :index="item.path"
              v-for="item in menuList"
              :key="item.path"
              >{{ item.name }}</el-menu-item
            >
          </el-menu>
        </page-aside>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import pageAside from "@/components/pageAside.vue";
import PageBread from "../../components/pageBread.vue";
export default {
  name: "",
  data() {
    return {
      menuList: [
        {
          name: "法律法规",
          path: "/lawFiles/regulations",
        },
        {
          name: "综合管理",
          path: "/lawFiles/management",
        },
         {
          name: "文件下载",
          path: "/lawFiles/file",
        },
      ],
    };
  },
  mounted() {},
  methods: {},
  components: {
    pageAside,
    PageBread,
  },
  computed: {
    activeIndex:function () {
      return this.menuList.find(item => this.$route.path.includes(item.path)).path
    }
  },
};
</script>

<style lang='scss' scoped>
.el-main {
  border-left: 8px solid #f4f4f4;
  padding: 0;
}
</style>